import React from "react";
import { usePermissions } from "@/hooks/use-permissions";
import { PermissionCheck } from "@/lib/list-permissions";

/**
 * Renders `Component` only while `check` passes for the current role. Otherwise it renders
 * nothing, and none of the component's hooks run, so it fires none of its queries.
 *
 * For controls that load a list the role may not be allowed to read: any 403 sends the whole page
 * to /dashboard/unauthorized (the response interceptor in client/index.ts), so a filter whose
 * options the role can't load is left out rather than offered, the way ImagesFilters already leaves
 * out the Dataset filter without datasets.view.
 */
export function withPermission<P extends object>(
  check: PermissionCheck,
  Component: React.ComponentType<P>,
) {
  function WithPermission(props: P) {
    const { permissions } = usePermissions();
    return check(permissions) ? <Component {...props} /> : null;
  }
  WithPermission.displayName = `withPermission(${Component.displayName ?? Component.name})`;
  return WithPermission;
}
